<template>
  <div class="main-container">
    <div class="bread">
      <router-link :to="{ name: 'MemberIntegral', query: { tab: 'store' } }">
        {{ $store.state.commonSetting.point_info.point_name }}商城
      </router-link>
      <span class="slash">&gt;</span>
      <span class="current">{{ detail.name }}</span>
    </div>
    <div class="info">
      <img
        class="cover"
        v-if="detail.goods_type == 2"
        :src="detail.cover_img"
      />
      <div class="right">
        <div class="name">{{ detail.name }}</div>
        <div class="integral-wrap">
          <span class="integral">{{ detail.exchange_price }}</span>
          <span class="integral-label">
            {{ $store.state.commonSetting.point_info.point_name }}
          </span>
          <span class="stock-wrap">
            <span class="sale-num">{{ detail.sales_num }}</span>
            <span>人已报名</span>
            <span class="line">|</span>
            <span>剩余：</span>
            <span class="surplus">{{ detail.surplus }}</span>
            <span>名额</span>
          </span>
        </div>
        <div class="valid-wrap" v-if="detail.goods_type == 1">
          <p v-if="studyStatus">
            <span>学习有效期：</span>
            <span v-if="detail.valid_type == 1">长期有效</span>
            <span v-else>
              <span>{{ detail.valid_end_time | tsFormatDate }}</span>
              <span v-html="endDayHtml"></span>
            </span>
          </p>
          <p v-if="continueStatus || exchangeStatus">
            <span>学习有效期：</span>
            <span v-if="detail.valid_type == 1">长期有效</span>
            <span v-else-if="detail.valid_type == 2">
              {{ detail.valid_time | tsFormatDate }}截止
            </span>
            <span v-else-if="detail.valid_type == 3">
              {{ detail.valid_time }}天
            </span>
            <el-popover
              placement="right"
              trigger="hover"
              v-if="detail.valid_type != 1"
              class="pop-help"
            >
              <img
                slot="reference"
                class="icon-help"
                src="@/assets/images/course/help@2x.png"
              />
              <p>
                {{
                  detail.valid_type == 2
                    ? "购买后，在此日期前，学员可进行学习"
                    : "购买后，可持续学习的天数"
                }}
              </p>
            </el-popover>
          </p>
        </div>
        <div class="btn-wrap">
          <a
            v-if="exchangeStatus || continueStatus"
            :class="{ 'btn-disabled': detail.surplus == 0 }"
            class="btn btn-primary"
            @click="beginExchange"
          >
            {{ exchangeStatus ? "立即兑换" : "立即续报" }}
          </a>
          <a
            v-if="exchangeStatus || continueStatus"
            class="btn btn-blank"
            @click="watchDetail"
          >
            查看详情
          </a>
          <a v-if="studyStatus" class="btn btn-primary" @click="joinStudy">
            立即学习
          </a>
        </div>
      </div>
    </div>
    <div class="detail-wrap">
      <div v-if="detail.goods_type" class="title">
        {{ detail.goods_type == 1 ? "课程介绍" : "商品介绍" }}
      </div>
      <div class="detail" v-html="detail.intro"></div>
    </div>
    <el-dialog
      class="dialog-custom"
      title="配送至"
      :visible.sync="showAddressModal"
      width="681px"
      appendToBody
      center
    >
      <Address
        v-model="addressId"
        :tip="
          detail.is_materials == 1 && detail.goods_type != 2
            ? '此地址只用于邮寄实体教材，请准确填写'
            : ''
        "
      ></Address>
      <div slot="footer" class="dialog-footer clear">
        <el-button
          type="default"
          size="small"
          @click="showAddressModal = false"
        >
          取消
        </el-button>
        <el-button type="primary" size="small" @click="confirmExchange">
          立即兑换
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Address from "../../components/Address";
export default {
  name: "IntegralGoodsDetail",
  components: {
    Address,
  },
  data() {
    return {
      id: this.$route.params.id,
      detail: {},
      showAddressModal: false,
      addressId: "",
    };
  },
  computed: {
    // 立即学习
    studyStatus() {
      if (this.continueStatus) {
        return false;
      }
      return this.detail.goods_type == 1 && this.detail.is_check == 2;
    },
    // 立即续报
    continueStatus() {
      const nowTs = parseInt(+new Date() / 1000);
      return (
        this.detail.goods_type == 1 &&
        this.detail.is_check == 2 &&
        this.detail.valid_type != 1 &&
        this.detail.valid_end_time <= nowTs
      );
    },
    // 立即兑换
    exchangeStatus() {
      return this.detail.goods_type == 2 || this.detail.is_check != 2;
    },
    endDayHtml() {
      let str = "";
      if (this.detail.valid_end_days > 2) {
        str = `（还有<font>${this.detail.valid_end_days}</font>天到期）`;
      } else if (this.detail.valid_end_days == 2) {
        str = `（<font>后天</font>到期）`;
      } else if (this.detail.valid_end_days == 1) {
        str = `（<font>明天</font>到期）`;
      } else if (this.detail.valid_end_days == 0) {
        str = `（<font>今天</font>到期）`;
      }
      return str;
    },
  },
  async created() {
    let data = await this.$http.get("/api/integral/shop/detail/" + this.id);
    data.surplus = data.stock - data.sales_num;
    this.detail = data;
  },
  methods: {
    async exchange() {
      let data = {
        integral_id: this.id,
        order_type: 6,
      };
      let shop_infos = [
        {
          shop_id: this.detail.goods_id,
          product_number: 1,
          shop_type: this.detail.goods_type == 1 ? this.detail.course_type : 12,
        },
      ];
      data.shop_infos = JSON.stringify(shop_infos);
      if (this.detail.goods_type == 2 || this.detail.is_materials == 1) {
        data.address_id = this.addressId;
      }
      await this.$http.post("/api/app/order/downOrder", {...data,point:0});
      this.$success("兑换成功");
      this.$router.push({ name: "MemberIntegral", query: { tab: "record" } });
    },
    async beginExchange() {
      if (this.detail.surplus == 0) {
        return;
      }
      if (this.detail.goods_type == 1 && this.detail.is_materials == 0) {
        await this.exchange();
      } else {
        this.showAddressModal = true;
      }
    },
    async confirmExchange() {
      if (this.addressId == "") {
        this.$warning("请选择收货地址");
        return;
      }
      await this.exchange();
    },
    async joinStudy() {
      this.$router.push({
        name: "MemberStudy",
        query: { type: this.detail.course_type },
      });
    },
    watchDetail() {
      this.$router.push({
        name: this.detail.goods_type == 1 ? "CourseShow" : "GoodsDetail",
        params: { id: this.detail.goods_id },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.bread {
  border-radius: 10px;
}
.pop-help {
  margin-left: 10px;
}
.icon-help {
  width: 15px;
  position: relative;
  top: 3px;
}
.info {
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  margin-top: 30px;
  padding: 30px 50px;
  margin-bottom: 30px;
  display: flex;
  .cover {
    width: 158px;
    height: 196px;
    margin-right: 25px;
    box-shadow: 2px 2px 6px 0px rgba(0, 0, 0, 0.4);
  }
  .name {
    height: 38px;
    font-size: 34px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(54, 56, 55, 1);
    line-height: 38px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 25px;
  }
  .integral-wrap {
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(238, 31, 31, 1);
    display: flex;
    height: 32px;
    margin-bottom: 20px;
  }
  .integral {
    font-size: 34px;
    line-height: 32px;
  }
  .integral-label {
    font-size: 22px;
    line-height: 34px;
  }
  .valid-wrap {
    margin-bottom: 20px;
    font-size: 14px;
    color: #999;
    /deep/ font {
      color: #ff2d27;
    }
  }
  .stock-wrap {
    margin-left: 30px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(89, 89, 89, 1);
    line-height: 38px;
    .sale-num {
      margin-right: 5px;
    }
    .line {
      margin: 0 20px;
      font-size: 14px;
    }
    .surplus {
      margin-right: 5px;
    }
  }
  .btn-wrap {
    .btn {
      width: 166px;
      height: 51px;
      display: inline-block;
      box-sizing: border-box;
      border-radius: 26px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 51px;
      text-align: center;
      cursor: pointer;
      margin-right: 25px;
    }
    .btn-primary {
      background: $primary-color;
      color: rgba(255, 255, 255, 1);
    }
    .btn-blank {
      background: rgba(255, 255, 255, 1);
      border: 1px solid $primary-color;
      color: $primary-color;
    }
    .btn-disabled {
      background: rgba(245, 245, 245, 1);
      color: #8c8c8c;
      cursor: not-allowed;
    }
  }
}
.detail-wrap {
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  margin-bottom: 70px;
  padding: 25px;
  .title {
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(38, 38, 38, 1);
    line-height: 22px;
    position: relative;
    padding-left: 10px;
    margin-bottom: 15px;
    &::before {
      content: "";
      position: absolute;
      width: 3px;
      height: 14px;
      background: $primary-color;
      border-radius: 2px;
      top: 4px;
      left: 0;
    }
  }
  .detail {
    font-size: 15px;
  }
}
</style>
